import { IDataGridButton } from '../interfaces/data-grid.interface';

function BuildGridButtonConsultar(
  disabled: (item) => boolean = null,
  hidden: (item) => boolean = null
): IDataGridButton {
  return {
    action: 'CONSULTAR',
    icon: 'search',
    color: 'primary',
    tooltip: 'Consultar',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonEditar(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'EDITAR',
    icon: 'edit',
    color: 'primary',
    tooltip: 'Editar',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonVerDocumento(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'VER_DOCUMENTO',
    icon: 'insert_drive_file',
    color: 'primary',
    tooltip: 'Ver documento',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonEliminar(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'ELIMINAR',
    icon: 'delete',
    color: 'primary',
    tooltip: 'Eliminar',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonGuardar(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'GUARDAR',
    icon: 'save',
    color: 'primary',
    tooltip: 'Guardar',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonCancelar(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'CANCELAR',
    icon: 'cancel',
    color: 'primary',
    tooltip: 'Cancelar',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonDescargar(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'DESCARGAR',
    icon: 'cloud_download',
    color: 'primary',
    tooltip: 'Descargar',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonCopiar(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'COPIAR',
    icon: 'file_copy',
    color: 'primary',
    tooltip: 'Copiar',
    disabled: disabled,
    hidden: hidden
  };
}

function BuildGridButtonCorregir(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'CORREGIR',
    icon: 'edit',
    color: 'primary',
    tooltip: 'Corregir',
    disabled,
    hidden
  };
}

function BuildGridButtonUpdateCronograma(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'UPDATECRONOGRAMA',
    icon: 'assignment',
    color: 'primary',
    tooltip: 'Actualizar Cronograma',
    disabled,
    hidden
  };
}

function BuildGridButtonSubsanarRequisito(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'SUBSANARREQUISITO',
    icon: 'info',
    color: 'primary',
    tooltip: 'Subsanar Requisito',
    disabled,
    hidden
  };
}


function BuildGridButtonValidarPago(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'VALIDARPAGO',
    icon: 'verified',
    color: 'primary',
    tooltip: 'Validar Pago',
    disabled,
    hidden
  };
}


function BuildGridButtonRegistrarVoucherPago(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'REGISTRARVOUCHERPAGO',
    icon: 'verified',
    color: 'primary',
    tooltip: 'Registrar Voucher de Pago',
    disabled,
    hidden
  };
}


function BuildGridButtonObservarVoucherPago(
  disabled: (item, rowIndex?) => boolean = null,
  hidden: (item, rowIndex?) => boolean = null
): IDataGridButton {
  return {
    action: 'OBSERVARVOUCHERPAGO',
    icon: 'announcement',
    color: 'primary',
    tooltip: 'Observar Voucher de Pago',
    disabled,
    hidden
  };
}

export const BuildGridButton = {
  CONSULTAR: BuildGridButtonConsultar,
  EDITAR: BuildGridButtonEditar,
  VER_DOCUMENTO: BuildGridButtonVerDocumento,
  ELIMINAR: BuildGridButtonEliminar,
  GUARDAR: BuildGridButtonGuardar,
  CANCELAR: BuildGridButtonCancelar,
  DESCARGAR: BuildGridButtonDescargar,
  COPIAR: BuildGridButtonCopiar,
  CORREGIR: BuildGridButtonCorregir,
  UPDATECRONOGRAMA: BuildGridButtonUpdateCronograma,
  SUBSANARREQUISITO: BuildGridButtonSubsanarRequisito,
  VALIDARPAGO: BuildGridButtonValidarPago,
  REGISTRARVOUCHERPAGO: BuildGridButtonRegistrarVoucherPago,
  OBSERVARVOUCHERPAGO: BuildGridButtonObservarVoucherPago
};
